var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.928 20.926L0 16 16 0h9.854L4.928 20.926zm20.926-6.162H16l-3.691 3.69 4.927 4.928",
    fill: "#42A5F5",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.309 28.309L16 32h9.854l-8.617-8.617",
    fill: "#0D47A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.393 23.385l4.92-4.921 4.92 4.92-4.92 4.92-4.92-4.919z",
    fill: "#42A5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 28.305l4.92-4.92.686.687-4.92 4.92-.686-.687z",
    fill: "url(#paint0_linear_1911_185)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.309 28.309l7.311-2.526-2.384-2.402",
    fill: "url(#paint1_linear_1911_185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1911_185",
    x1: 14.774,
    y1: 25.844,
    x2: 15.46,
    y2: 26.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1911_185",
    x1: 12.311,
    y1: 25.845,
    x2: 19.622,
    y2: 25.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#616161",
    stopOpacity: 0.01
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.fee99b320a64aba1bbe85d7792b7d296.svg";
export { ForwardRef as ReactComponent };